/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Serie202,
  PostApiV1Serie400,
  PostApiV1Serie401,
  PostApiV1Serie404,
  PostApiV1Serie500,
  PostApiV1SerieMutationRequest,
  PostApiV1SerieMutationResponse,
} from "../../types/serieRegistroController/PostApiV1Serie.ts";
import { serieViewModelSchema } from "../serieViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Serie202Schema = z.lazy(
  () => serieViewModelSchema,
) as unknown as ToZod<PostApiV1Serie202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Serie400Schema =
  z.any() as unknown as ToZod<PostApiV1Serie400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Serie401Schema =
  z.any() as unknown as ToZod<PostApiV1Serie401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1Serie404Schema =
  z.any() as unknown as ToZod<PostApiV1Serie404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Serie500Schema =
  z.any() as unknown as ToZod<PostApiV1Serie500>;

export const postApiV1SerieMutationRequestSchema = z.object({
  CompanyId: z.optional(z.number().int()),
  Title: z.optional(z.string()),
  Resumee: z.optional(z.string()),
  Active: z.optional(z.boolean()),
  IsGeneral: z.optional(z.boolean()),
  Thumbnail: z.optional(z.instanceof(File)),
  ClassStudentIds: z.optional(z.array(z.number().int())),
}) as unknown as ToZod<PostApiV1SerieMutationRequest>;

export const postApiV1SerieMutationResponseSchema = z.lazy(
  () => postApiV1Serie202Schema,
) as unknown as ToZod<PostApiV1SerieMutationResponse>;
